import $ from 'jquery';

window.$ = $;
window.jQuery = $;

import 'slick-carousel';